import React from 'react'
import { Box } from '@mui/material'

/**
 * 必須項目バッジ
 *
 * フォームUX_バリデーション共通設計方針 §3 に準拠。
 * ラベルの「＊」は使用せず、薄紅（薄い赤）枠の四角い小バッジ「必須」で必須項目を明示する。
 * 任意項目にはバッジを付与しない。
 *
 * デザイントークン（同方針 §3.2）:
 *   背景 #FFEBEE / 枠 #EF9A9A / 文字 #C62828 / 角丸4px
 */
interface RequiredBadgeProps {
  label?: string
}

const RequiredBadge: React.FC<RequiredBadgeProps> = ({ label = '必須' }) => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        bgcolor: '#FFEBEE',
        border: '1px solid #EF9A9A',
        color: '#C62828',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: 500,
        lineHeight: 1,
        px: '6px',
        py: '2px',
      }}
    >
      {label}
    </Box>
  )
}

export default RequiredBadge
